export const ROUTES = {
  LOGIN: '/',
  LOGIN_VALIDATION: '/valida-login',
  TERMS_OF_USE_AND_CONFIDENTIALITY: '/termo',
  HOME: '/painel',
  MENU_USER: '/menu-usuario',
  MANAGE_USER: '/usuarios',
  USER_CREATE: '/usuarios/cadastrar',
  USER_EDIT: '/usuarios/editar/:uuid',
  USER_VIEW: '/usuarios/visualizar/:uuid',
  INSTITUTION: '/instituicoes',
  INSTITUTION_VIEW: '/instituicoes/visualizar/:uuid',
  INSTITUTION_EDIT: '/instituicoes/editar/:uuid',
  MANAGE_PROFILES: '/perfis',
  PROFILES_CREATE: '/perfis/cadastrar',
  MANAGE_PERMISSIONS: '/permissoes',
  PERMISSIONS_CREATE: '/permissoes/cadastrar',
  PERMISSIONS_EDIT: '/permissoes/editar/:uuid',
  PERMISSIONS_VIEW: '/permissoes/visualizar/:uuid',
  MANAGE_SERVICE: '/menu-servicos',
  MANAGE_CIFA: '/menu-cifas',
  CIFA: '/cifa',
  CIFA2025: '/cifa-2025',
  INCLUDE_CIFA_2025: '/cifa-2025/cadastrar/ater',
  VIEW_CIFA_2025: '/cifa-2025/visualizar/ater',
  EDIT_CIFA_2025: '/cifa-2025/editar/ater',
  CREATE_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-federal',
  VIEW_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-federal',
  EDIT_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-federal',
  CREATE_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-estadual',
  VIEW_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-estadual',
  EDIT_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-estadual',
  CREATE_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-municipal',
  CREATE_CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/cadastrar/confirmar-dados',
  EDIT_CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/editar/confirmar-dados',
  VIEW_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-municipal',
  EDIT_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-municipal',
  CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/confirmar-dados',

  CIFA2026: '/cifa-2026',
  INCLUDE_CIFA_2026: '/cifa-2026/cadastrar/ater',
  COMPLIANCE_TERM_2026: '/cifa-2026/cadastrar/compliance-term',
  TECH_ASSIST_2026: '/cifa-2026/cadastrar/tech-assist',
  SCHOOL_FEEDING_ACQUISITIONS_2026: '/cifa-2026/cadastrar/school-feeding-acquisitions',
  FINANCIAL_RESOURCE_2026: '/cifa-2026/cadastrar/financial-resource',
  SCHOOL_FEEDING_2026: '/cifa-2026/cadastrar/school-feeding',

  VIEW_CIFA_2026: '/cifa-2026/visualizar/ater',
  VIEW_COMPLIANCE_TERM_2026: '/cifa-2026/visualizar/compliance-term',
  VIEW_TECH_ASSIST_2026: '/cifa-2026/visualizar/tech-assist',
  VIEW_SCHOOL_FEEDING_ACQUISITIONS_2026: '/cifa-2026/visualizar/school-feeding-acquisitions',
  VIEW_FINANCIAL_RESOURCE_2026: '/cifa-2026/visualizar/financial-resource',
  VIEW_SCHOOL_FEEDING_2026: '/cifa-2026/visualizar/school-feeding',

  CIFA2027: '/cifa-2027',
  INCLUDE_CIFA_2027: '/cifa-2027/cadastrar/ater',
  COMPLIANCE_TERM_2027: '/cifa-2027/cadastrar/compliance-term',
  TECH_ASSIST_2027: '/cifa-2027/cadastrar/tech-assist',
  SCHOOL_FEEDING_ACQUISITIONS_2027: '/cifa-2027/cadastrar/school-feeding-acquisitions',
  FINANCIAL_RESOURCE_2027: '/cifa-2027/cadastrar/financial-resource',
  SCHOOL_FEEDING_2027: '/cifa-2027/cadastrar/school-feeding',

  VIEW_CIFA_2027: '/cifa-2027/visualizar/ater',
  VIEW_COMPLIANCE_TERM_2027: '/cifa-2027/visualizar/compliance-term',
  VIEW_TECH_ASSIST_2027: '/cifa-2027/visualizar/tech-assist',
  VIEW_SCHOOL_FEEDING_ACQUISITIONS_2027: '/cifa-2027/visualizar/school-feeding-acquisitions',
  VIEW_FINANCIAL_RESOURCE_2027: '/cifa-2027/visualizar/financial-resource',
  VIEW_SCHOOL_FEEDING_2027: '/cifa-2027/visualizar/school-feeding',

  FIRSTUSER: '/first-user',
  FIRSTUSERCREATE: '/first-user/cadastrar',
  FIRSTUSERSTEPS: '/primeiro-usuario/cadastrar',

  TERMOFADHESION: '/termo-de-adesao',
  REGISTERTERMOFADHESION: '/termo-de-adesao/cadastrar',
  VIEWTERMSADHESION: '/termo-de-adesao/visualizar/:uuid',
  VALIDATETERMSADHESION: '/termo-de-adesao/validar/:uuid',
  EDITTETERMSADHESION: '/termo-de-adesao/editar/:uuid',

  // Pacote de formulários
  PACOTE_FORMULARIOS: '/pacote-de-formularios',
  PACOTE_FORMULARIOS_ID: '/pacote-de-formularios/:uuid',

  // Pacote de formulários - CMDRDS
  PACOTE_FORMULARIOS_CMDRS_EDITAR:
    '/pacote-de-formularios/cmdrs/editar/:uuid',
  PACOTE_FORMULARIOS_VISUALIZAR_EDITAR:
    '/pacote-de-formularios/cmdrs/visualizar/:uuid',

  // Pacote de formulários - CMDRDS
  PACOTE_FORMULARIOS_SIM_EDITAR:
    '/pacote-de-formularios/sim/editar/:uuid',
  PACOTE_FORMULARIOS_SIM_VISUALIZAR:
    '/pacote-de-formularios/sim/visualizar/:uuid',

  // Pacote de formulários - Secretaria Municipal de Agricultura
  PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_VISUALIZAR:
    '/pacote-de-formularios/secretaria_municipal_agricultura/visualizar/:uuid',
  PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_EDITAR:
    '/pacote-de-formularios/secretaria_municipal_agricultura/editar/:uuid',

  // Pacote de formulários - Politica Municipal da Agricultura Familiar
  PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_VISUALIZAR:
    '/pacote-de-formularios/politica_municipal_agricultura_familiar/visualizar/:uuid',
  PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_EDITAR:
    '/pacote-de-formularios/politica_municipal_agricultura_familiar/editar/:uuid',

  // Pacote de formulários - Politica Municipal da Agricultura Familiar
  PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_VISUALIZAR:
    '/pacote-de-formularios/comunidades_rurais_tradicionais/visualizar/:uuid',
  PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_EDITAR:
    '/pacote-de-formularios/comunidades_rurais_tradicionais/editar/:uuid',

  // Pacote de formulários - Questões Ambientais
  PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_VISUALIZAR:
    '/pacote-de-formularios/questoes_ambientais/visualizar/:uuid',
  PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_EDITAR:
    '/pacote-de-formularios/questoes_ambientais/editar/:uuid',

  DADOS_GERAIS_CICAAF: '/cicaaf/coleta/dados-gerais',
};
